/**
 * Transform API data to the format expected by the UI
 * Groups videos by categories
 */
export function transformVideosToSlides(categories, videos) {
  if (!categories || !videos || categories.length === 0 || videos.length === 0) {
    return { series: [], films: [] };
  }

  // Create a map of category name to videos
  const categoryMap = {};

  categories.forEach((category) => {
    categoryMap[category.name] = {
      title: category.name,
      data: [],
    };
  });

  // Group videos by their categories
  videos.forEach((video) => {
    console.log(`🎥 Processing video: "${video.title}", categories:`, video.categories);

    // Transform video to match the expected format
    const transformedVideo = {
      docId: video._id,
      id: video._id,
      slug: video.slug,
      title: video.title,
      description: video.synopsis || '',
      genre: video.theme?.[0]?.toLowerCase() || 'general',
      maturity: video.ageRating?.code || 'G',

      // Additional fields from API
      videoUrl: video.videoUrl,
      thumbnail: video.thumbnail || '',
      releaseDate: video.releaseDate,
      duration: video.duration,
      country: video.country,
      rating: video.rating,
      views: video.views,
      theme: video.theme || [],
      categories: video.categories || [],
      director: video.director,
      cast: video.cast || [],
      highlights: video.highlights || [],
      trailer: video.trailer,
    };

    // Add video to each of its categories
    if (video.categories && Array.isArray(video.categories)) {
      video.categories.forEach((categoryName) => {
        if (categoryMap[categoryName]) {
          categoryMap[categoryName].data.push(transformedVideo);
        }
      });
    }
  });

  // Convert map to array and filter out empty categories
  const slideRows = Object.values(categoryMap).filter((cat) => cat.data.length > 0);

  console.log(`📊 Transform complete: ${slideRows.length} categories with videos`);
  slideRows.forEach((row) => {
    console.log(`  - ${row.title}: ${row.data.length} videos`);
  });

  // Transform all videos to the expected format (for "all films" view)
  const allVideos = videos.map((video) => ({
    docId: video._id,
    id: video._id,
    slug: video.slug,
    title: video.title,
    description: video.synopsis || '',
    genre: video.theme?.[0]?.toLowerCase() || 'general',
    maturity: video.ageRating?.code || 'G',
    videoUrl: video.videoUrl,
    thumbnail: video.thumbnail || '',
    releaseDate: video.releaseDate,
    duration: video.duration,
    country: video.country,
    rating: video.rating,
    views: video.views,
    theme: video.theme || [],
    categories: video.categories || [],
    director: video.director,
    cast: video.cast || [],
    highlights: video.highlights || [],
    trailer: video.trailer,
  }));

  console.log(`📊 All videos (ungrouped): ${allVideos.length} videos`);

  // Return data in two formats:
  // - series: grouped by categories (for "Dành cho bạn" tab)
  // - films: all videos in single group (for "Tất cả phim" tab)
  return {
    series: slideRows, // Grouped by categories
    films: [{ title: 'Tất cả phim', data: allVideos }], // All videos in one group
  };
}

/**
 * Legacy function - kept for backward compatibility
 * This is the old selection filter that worked with mock data
 */
export function selectionFilterLegacy({ series, films } = []) {
  return {
    series: [
      {
        title: 'Documentaries',
        data: series?.filter((item) => item.genre === 'documentaries'),
      },
      {
        title: 'Comedies',
        data: series?.filter((item) => item.genre === 'comedies'),
      },
      {
        title: 'Children',
        data: series?.filter((item) => item.genre === 'children'),
      },
      {
        title: 'Crime',
        data: series?.filter((item) => item.genre === 'crime'),
      },
      {
        title: 'Feel Good',
        data: series?.filter((item) => item.genre === 'feel-good'),
      },
    ],
    films: [
      { title: 'Drama', data: films?.filter((item) => item.genre === 'drama') },
      {
        title: 'Thriller',
        data: films?.filter((item) => item.genre === 'thriller'),
      },
      {
        title: 'Children',
        data: films?.filter((item) => item.genre === 'children'),
      },
      {
        title: 'Suspense',
        data: films?.filter((item) => item.genre === 'suspense'),
      },
      {
        title: 'Romance',
        data: films?.filter((item) => item.genre === 'romance'),
      },
    ],
  };
}

// Default export for backward compatibility
export default selectionFilterLegacy;
